import ActivitiesWeekly from "./weekly"
import DailyCalendarLayout from "../daily-calendar/daily-calendar-layout"
import { cn } from "@/lib/utils"

interface ActivitiesProps {
  selectedTab: string
  handleOnChangeTab: (value: string) => void
  scrollWeeklyRef: React.RefObject<HTMLDivElement>
  isSticky?: boolean
}

export default function Activities({
  selectedTab,
  handleOnChangeTab,
  scrollWeeklyRef,
  isSticky = false,
}: ActivitiesProps) {
  return (
    <div className={cn("flex h-full flex-col gap-4", isSticky && "pt-52")}>
      <div className="flex size-full">
        {selectedTab === "weekly" ? (
          <ActivitiesWeekly scrollRef={scrollWeeklyRef} />
        ) : (
          <DailyCalendarLayout
            onClickActivitiesExceeded={() => handleOnChangeTab("weekly")}
            mainHeaderIsSticky={isSticky}
          />
        )}
      </div>
    </div>
  )
}
